import { IconNameType, Link, RstIcon } from '@rst/ui-ts'
import React from 'react'

export const SocialLink: React.FC<{ link?: string; icon: IconNameType }> = ({
	link,
	icon,
}) => {
	if (!link) return null
	return (
		<Link target={'_black'} href={link}>
			<RstIcon type={icon} />
		</Link>
	)
}
